import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "~hooks/useNotification";
import { useApi } from "~shared/api";

export const useResetFixture = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const { mutateData } = useApi();
  const notification = useNotification();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fixtureId: string) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${fixtureId}/reset?forceDelete=true`,
        method: "POST",
      });
    },
    onSuccess: (response: any) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.invalidateQueries({
          queryKey: ["fixtureListPage", sport, organizationId, seasonId],
        });
        notification.success({
          message: formatMessage({ id: "fixture.clear.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
